import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import type Patient from 'parog-web/models/patient';
import PageContainer from 'ui-kit/components/page-container';
interface Signature {
  Args: {
    patient?: Patient;
  };
}

const AskForPrescription: TOC<Signature> = <template>
  <PageContainer>
    <:content>
      <p class='ui header'>
        Voulez-vous générer l'ordonnance pour ce nouveau traitement ?
      </p>

      <div class='form-buttons'>
        <LinkTo
          class='ui button fluid form-button'
          data-test-button='no'
          @route='medics-web.protected.patients.patient.dashboard'
          @model={{@patient}}
        >NON</LinkTo>

        <LinkTo
          @route='medics-web.protected.patients.patient.medication-prescription.edition-form'
          @model={{@patient.id}}
          class='ui button primary fluid form-button'
          data-test-button='yes'
        >
          OUI
        </LinkTo>
      </div>
    </:content>
  </PageContainer>
</template>;

export default AskForPrescription;
